import { directionNewsTagOptions, type DirectionId } from './labDirectionTags';

export type ProjectDirection = DirectionId;

export const projectDirectionOptions = directionNewsTagOptions.map(({ id, label }) => ({ id, label }));

export function normalizeProjectDirections(value: unknown): ProjectDirection[] {
  if (!Array.isArray(value)) return [];
  return projectDirectionOptions.filter(({ id }) => value.includes(id)).map(({ id }) => id);
}

export function toggleProjectDirection(
  selected: readonly ProjectDirection[],
  direction: ProjectDirection,
): ProjectDirection[] {
  return normalizeProjectDirections(
    selected.includes(direction) ? selected.filter(id => id !== direction) : [...selected, direction],
  );
}
